export default "__VITE_ASSET__f4632fc2__"